import { useEffect } from "react";
import { Button, Popover, Whisper } from "rsuite";
import Item from "./Components/Item/Item";
import styles from "./ItemsBlock.module.css";
import { isAttachedFilesBlockAvaliable } from "../../../../helperFunctions";
import { IoDocumentTextOutline } from "react-icons/io5";
import FilesUploader from "./Components/FilesUploader/FilesUploader";
import { useItemsBlock } from "./useItemsBlock";
import AttachedFiles from "./Components/AttachedFiles/AttachedFiles";
import { usePurchaseOrders } from "../../usePurchaseOrders";

function ItemsBlock({ onChange, readonly, showReceived, itemReadonly }) {
  const { addItem, deleteItem, itemHandler } = useItemsBlock();

  const { form, ongenerateRLPreview, generatingRL, countFormChanges } =
    usePurchaseOrders();

  const isDisabledRLPreview = countFormChanges > 1;
  const isAddDisabled = form.type === undefined;
  const addButton = (
    <>
      <Button
        disabled={isAddDisabled}
        onClick={addItem}
        appearance="primary"
        style={{ width: 100, margin: "15px 0px 15px 0px" }}
      >
        Add Item
      </Button>
    </>
  );

  // const showAttachedFilesBlock = isAttachedFilesBlockAvaliable(
  //   form.status,
  //   form.attachedFiles.length
  // );
  const tooltip = isDisabledRLPreview ? (
    <Popover>
      Save the form before generating the requisition form preview
    </Popover>
  ) : (
    <Popover>Generate a preview of the Requisition Form</Popover>
  );
  const previewRLButton = (
    <>
      <Whisper
        placement="topStart"
        delayOpen={800}
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <Button
          disabled={isDisabledRLPreview}
          loading={generatingRL}
          onClick={() => {
            ongenerateRLPreview(form._id, form.requisitionNumber);
          }}
          appearance="default"
          style={{ width: 200, margin: "15px 0px 15px 20px" }}
        >
          Preview Requisition Form
        </Button>
      </Whisper>
    </>
  );

  const previewRFButton = (
    <>
      <Whisper
        placement="topStart"
        delayOpen={800}
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <Button
          loading={generatingRL}
          onClick={() => {
            ongenerateRLPreview(form._id);
          }}
          appearance="subtle"
          style={{ width: 50, marginLeft: 30 }}
        >
          <IoDocumentTextOutline style={{ width: 45 }} />
        </Button>
      </Whisper>
    </>
  );

  return (
    <>
      <div className={styles.container}>
        <div className={styles.titles}>
          <div>#</div>
          <div>Item Description</div>
          <div>Part No.</div>
          <div>Unit</div>
          <div>Qty</div>
          <div>ROB</div>
          {showReceived && <div>Received</div>}
        </div>

        {form?.items.map((item, index) => (
          <> 
            <Item
              itemIndex={index + 1}
              readonly={readonly}
              itemReadonly={itemReadonly}
              itemId={item.id}
              form={item}
              onChange={itemHandler}
              onDelete={() => {
                deleteItem(item.id);
              }}
              showReceived={showReceived}
            />
          </>
        ))}

        <div className={styles.buttons}>
          {readonly ? <></> : addButton}

          {readonly || form.requisitionNumber === undefined ? (
            <></>
          ) : (
            previewRLButton
          )}
        </div>
        {/* {showAttachedFilesBlock && <AttachedFiles />} */}
        <AttachedFiles />
      </div>
    </>
  );
}

export default ItemsBlock;
